<template>
	<v-card class="mx-auto" elevation="0">
		<v-card-title class="card-header fixed-card-title2">
			{{ $t('edit-location-mapping-pcc') }}
			<v-spacer></v-spacer>
			<v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
		</v-card-title>
		<v-card-text>
			<v-row dense class="my-2">
				<v-col cols="12">
					<v-select
						class="py-1"
						hide-details
						dense
						v-model="pccSelectedLocationToEdit.mappedOrganizationId"
						:items="allMedicalInstitutions"
						item-value="id"
						item-text="institutionName"
						:label="$t('organizations')"
						outlined />
				</v-col>

				<v-col cols="12">
					<v-select
						:items="notMappedLocationsFiltered"
						item-text="hospitalName"
						item-value="id"
						outlined
						hide-details
						dense
						:label="`${$t('location')}`"
						v-model="pccSelectedLocationToEdit.mappedHospitalId" />
				</v-col>

				<v-col cols="12">
					<v-textarea
						outlined
						hide-details
						dense
						:label="`${$t('description')}`"
						v-model="pccSelectedLocationToEdit.description"
						rows="3" />
				</v-col>

				<v-col cols="12">
					<v-checkbox
						outlined
						dense
						hide-details="auto"
						v-model="pccSelectedLocationToEdit.finalizeMeasurementAutomatically"
						:label="`${$t('finalize-measurement-automatically')}`" />
				</v-col>

				<v-col cols="12">
					<v-checkbox
						outlined
						dense
						hide-details="auto"
						v-model="pccSelectedLocationToEdit.residentCreationIsAutomatic"
						:label="`${$t('resident-creation-is-automatic')}`" />
				</v-col>

				<v-col cols="12">
					<v-checkbox
						outlined
						dense
						hide-details="auto"
						v-model="pccSelectedLocationToEdit.userCreationIsAutomatic"
						:label="`${$t('user-creation-is-automatic')}`" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions class="fixed-card-actions">
			<v-row dense class="mx-0 px-0 mr-2">
				<v-col cols="6">
					<v-btn elevation="0" @click="closeDrawer" class="cancel-button-style capitalize-text">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn
						:disabled="isSaveLocationMappingButtonDisabled()"
						@click="editLocationMapping"
						class="save-button-style">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import MappingRepository from '../../data/repositories/v1/MappingRepository';
import { showSuccessAlert } from '../../utils/utilities';

export default {
	name: 'LocationMappingEdit',
	data: () => ({
		componentKey: 0,
		menu: false,
		defaultTimeZone: 'America/Chicago',
		selectedMedicalInstitution: null,
		pccCompanyGuid: '',
		pccCompanyName: '',
		pccSelectedLocationToEdit: {
			pccLocationId: 0,
			mappedHospitalId: 0,
			mappedOrganizationId: 0,
			pccLocationName: '',
			finalizeMeasurementAutomatically: false,
			residentCreationIsAutomatic: false,
			userCreationIsAutomatic: false,
			additionalData: '',
			description: '',
		},
		notMappedLocationsFiltered: [],
		notMappedLocations: [],
		pccMappedLocations: [],
		pccLocations: [],
		mappedPccOrganizations: [],
	}),
	computed: {
		...mapState({
			allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
			hospitals: (state) => state.hospitals.hospitals,
			pccSelectedLocation: (state) => state.mapping.pccSelectedLocation,
			updateDrawer: (state) => state.updateDrawer,
		}),
		...mapGetters({
			getTimeZone: 'verifiers/getTimeZone',
			getPccSelectedLocation: 'mapping/getPccSelectedLocation',
		}),
	},
	async mounted () {
		await Promise.all([this.getEcpNotMappedLocation(), this.getPccNotMappedLocation(), this.getMappedOrganizations()]);
		this.pccSelectedLocationToEdit = this.pccSelectedLocation;
	},
	methods: {
		...mapActions({
			getMappedPccOrganizations: 'pcc/getMappedPccOrganizations',
		}),

		async getMappedOrganizations () {
			this.mappedPccOrganizations = await this.getMappedPccOrganizations();
		},
		async getPccNotMappedLocation () {
			this.pccMappedLocations = await MappingRepository.getMappedPccLocation();
		},
		isSaveLocationMappingButtonDisabled () {
			return this.pccSelectedLocationToEdit.pccLocationName?.length === 0;
		},
		resetComponent () {
			this.pccSelectedLocationToEdit = {
				id: -1,
				pccCompanyId: '',
				pccCompanyName: '',
				medicalInstitution: null,
			};
		},
		async editLocationMapping () {
			MappingRepository.updatePccMapForLocation(this.pccSelectedLocationToEdit).then((res) => {
				if (res.resFlag) {
					showSuccessAlert(res.msg);
				}
				this.closeDrawer();
			});
		},
		closeDrawer () {
			this.resetComponent();
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
		},
		medicalInstitutionSelected () {
			return this.pccSelectedLocationToEdit.medicalInstitution;
		},
		async getEcpNotMappedLocation () {
			this.notMappedLocations = await MappingRepository.getNotMappedEcpLocation();
		},
	},
	watch: {
		'pccSelectedLocationToEdit.mappedOrganizationId': {
			immediate: false,
			deep: true,
			async handler (val) {
				this.notMappedLocationsFiltered = this.notMappedLocations.filter((n) => n.medicalInstitutionId === val);
			},
		},
		async 'pccSelectedLocationToEdit.pccCompanyId' (val) {
			if (!val) return;
			this.pccLocations = (await this.getPCCFacilities(val)).filter((e) => e.pccLocationsMapping.length === 0);
		},
		updateDrawer (val) {
			if (val === true) {
				this.pccSelectedLocationToEdit = this.pccSelectedLocation;
			}
		},
	},
};
</script>
<style scoped>
.map-container {
	margin-top: 20px;
	/* Adjust this margin as needed */
}
</style>
